import { PureComponent } from "react";
import colors from "/styles/colors";
import AllRightsReservedComponent from "./all-rights-reserved/all-rights-reserved-component";
import FooterCategoryComponent from "./footer-category/footer-category-component";
import PictureComponent from "/components/core/picture/picture-component";
import { componentStyles } from "./footer-component.scss";
import { SocialFooterLinks, SecurityLogoLinks } from "/constants/links";
import SocialFooterComponent from "./social-footer/social-footer-component";
import { getFooterComponents } from "/services/localization/localization-service";
import { withGenericConfig } from "/contexts/generic-config-context";
import { withAbTests } from "contexts/ab-tests-context";

const ISO_LOGO_SRC = "/static/img/footer/iso-logo1.png";
const GDPR_LOGO_SRC = "/static/img/footer/gdpr-logo.png";
const SOC_LOGO_SRC = "/static/img/footer/soc-logo.png";
const HIPAA_LOGO_SRC = "/static/img/footer/hipaa-logo.png";

const ISO = "iso";
const SOC = "soc";
const GDPR = "gdpr";
const HIPAA = "hipaa";

class FooterComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.goToIsoPage = this.goToSecurityPage.bind(this, ISO);
    this.goToSocPage = this.goToSecurityPage.bind(this, SOC);
    this.goToGdprPage = this.goToSecurityPage.bind(this, GDPR);
    this.goToHipaaPage = this.goToSecurityPage.bind(this, HIPAA);
  }

  goToSecurityPage(page) {
    window.location = SecurityLogoLinks[page];
  }

  render() {
    const { footerBg, footerTextColor, translate, localeId, abTests } = this.props;
    const footerComponents = getFooterComponents(localeId, abTests);
    const {
      OurProductFooterLinks,
      OurTeamFooterLinks,
      UseCasesFooterLinks,
      HelpFooterLinks,
      NewSecurityFooterLinks
    } = footerComponents;

    return (
      <footer
        className="footer-container"
        style={{ backgroundColor: colors[footerBg], color: colors[footerTextColor] }}
      >
        <div className="footer-content-container">
          <div className="footer-content">
            <div className="all-right-reserved-container">
              <AllRightsReservedComponent SocialFooterLinks={SocialFooterLinks} />
            </div>

            <div className="categories-container">
              {OurProductFooterLinks && (
                <div className="category-container">
                  <FooterCategoryComponent
                    title={translate(OurProductFooterLinks.title)}
                    links={OurProductFooterLinks.links}
                  />
                </div>
              )}

              {OurTeamFooterLinks && (
                <div className="category-container">
                  <FooterCategoryComponent
                    title={translate(OurTeamFooterLinks.title)}
                    links={OurTeamFooterLinks.links}
                  />
                </div>
              )}

              {UseCasesFooterLinks && (
                <div className="category-container">
                  <FooterCategoryComponent
                    title={translate(UseCasesFooterLinks.title)}
                    links={UseCasesFooterLinks.links}
                  />
                </div>
              )}

              <div className="category-container">
                {HelpFooterLinks && (
                  <FooterCategoryComponent title={translate(HelpFooterLinks.title)} links={HelpFooterLinks.links} />
                )}
                {NewSecurityFooterLinks && (
                  <FooterCategoryComponent
                    title={translate(NewSecurityFooterLinks.title)}
                    links={NewSecurityFooterLinks.links}
                  />
                )}
                <div className="security-logos-container">
                  <div className="iso-logo-img-container" onClick={this.goToIsoPage}>
                    <PictureComponent src={ISO_LOGO_SRC} alt={"iso"} />
                  </div>

                  <div className="gdpr-logo-img-container" onClick={this.goToGdprPage}>
                    <PictureComponent src={GDPR_LOGO_SRC} alt={"gdpr"} />
                  </div>

                  <div className="soc-logo-img-container" onClick={this.goToSocPage}>
                    <PictureComponent src={SOC_LOGO_SRC} alt={"soc"} />
                  </div>
                  <div className="hipaa-logo-img-container" onClick={this.goToHipaaPage}>
                    <PictureComponent src={HIPAA_LOGO_SRC} alt={"hipaa"} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <SocialFooterComponent SocialFooterLinks={SocialFooterLinks} />
        <style jsx>{componentStyles}</style>
      </footer>
    );
  }
}

FooterComponent.defaultProps = {
  footerBg: "snow"
};

export default withAbTests(withGenericConfig(FooterComponent));
